import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { Magnetic } from "@/components/motion/Magnetic";
import { BOOKING_PATH, VIDEO_CTA_SOURCES } from "@/lib/site";
import { SectionVideo } from "@/components/motion/SectionVideo";
import { useLang } from "@/i18n/LanguageContext";
import { trackClick } from "@/lib/track";

export const FinalCTA = () => {
  const { t } = useLang();
  const f = t.finalCta;
  return (
    <section className="relative py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] panel p-9 lg:p-16 text-center" data-testid="final-cta">
            <SectionVideo sources={VIDEO_CTA_SOURCES} poster="/posters/cta.jpg" fill dim={0.64} rounded="rounded-[2rem]" testId="final-cta-video" className="z-0" />
            <div className="bg-grid bg-grid-fade absolute inset-0 opacity-50" style={{ zIndex: 1 }} />
            <div className="glow-orb animate-glow" style={{ zIndex: 1, width: 480, height: 300, top: -80, left: "50%", transform: "translateX(-50%)", background: "var(--blue)", opacity: 0.35 }} />
            <div className="relative" style={{ zIndex: 3 }}>
              <span className="eyebrow">{f.eyebrow}</span>
              <h2 className="mt-5 mx-auto max-w-3xl font-display text-3xl sm:text-4xl lg:text-5xl font-semibold leading-[1.1] text-[var(--white)]" data-testid="final-cta-headline">
                {f.title}
              </h2>
              <p className="mt-5 mx-auto max-w-xl text-muted">{f.sub}</p>
              <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
                <Magnetic>
                  <a href={`${BOOKING_PATH}?src=final`} onClick={() => trackClick("book_time")} className="btn-primary" data-testid="final-cta-book">
                    {f.book} <ArrowUpRight size={18} />
                  </a>
                </Magnetic>
                <a href="#kontakt" onClick={() => trackClick("contact")} className="btn-ghost" data-testid="final-cta-contact">
                  {f.contact}
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
